import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { QuantityUnitReference } from '../../../core/api/quantity-units/entities/quantity-unit-reference.entity';
import { StaticDataService } from '../../../core/services/static-data.service';
import { fieldIsRequired } from '../../utils/forms.utils';

@Component({
  selector: 'app-quantity-unit-input',
  templateUrl: './quantity-unit-input.component.html',
  styleUrl: './quantity-unit-input.component.scss',
})
export class QuantityUnitInputComponent implements OnInit {
  @Input({ required: true }) control!: FormControl<QuantityUnitReference | null>;
  @Input() label: string = 'Quantity Unit';

  isRequired = fieldIsRequired;
  options: QuantityUnitReference[] = [];

  constructor(private staticDataService: StaticDataService) {}

  ngOnInit(): void {
    this.staticDataService.getQuantityUnits().subscribe(quantityUnits => {
      this.options = quantityUnits;
    });
  }
}
